import React from 'react';

type Props = {
  word: string;
  // Array of characters
  guessedLetters: Array<string>;
  onWordGuessed?: () => void;
};

function MaskedWordDisplay({word, guessedLetters, onWordGuessed}: Props): React.JSX.Element {
  const letters = Array.from(word);

  React.useEffect(() => {
    if (onWordGuessed && !letters.find((letter) => !guessedLetters.includes(letter))) {
      onWordGuessed();
    }
  }, [letters, guessedLetters, onWordGuessed]);

  return (
    <span className="masked-word">
      {
        letters.map((letter, idx) => (
          <span key={idx} className="letter">
            {guessedLetters.includes(letter) ? letter : '_'}
          </span>
        ))
      }
    </span>
  );
}

export default MaskedWordDisplay;
